<template>
    <b-container fluid>
       <b-row>
          <b-col sm="12">
               <card>
                  <template v-slot:headerTitle>
                        <h4 class="card-title">User Details</h4>
                  </template>
                  <template v-slot:headerAction>
                     <div class="float-right details">
                        <h6 v-if="user.status==0">
                           <span>Status: </span>
                           <span class="text-danger">Blocked</span><br>
                           <span>Blocked by: {{user.blocked_by}}</span>
                        </h6>
                        <h6 v-else-if="user.status==1">
                           <span>Status: </span>
                           <span class="text-green">Active</span>
                        </h6>
                     </div>
                  </template>
                  <template v-slot:body>
                     <div class="details">  
                        <b-row>
                           <b-col md="6" lg="2"> 

                              <img v-if="user.image" :src="$image_url + user.image" alt="Image not found" class="img-fluid avatar-120 rounded-small">
                              <img v-else :src="$image_url + user.default_image" alt="Image not found" class="img-fluid avatar-120 rounded-small">
                           </b-col> 

                           <b-col md="6" lg="4">
                              <h6>Name:</h6>
                              <p>{{user.name}}</p>
                              <h6>Contact</h6>
                              <p class="mb-0">{{user.countrycode}} {{user.phone_number}}</p>
                              <p>{{user.email}}</p>
                           </b-col> 

                           <b-col md="6" lg="3">
                              <h6>Followers:</h6>
                              <p>{{user.followers}}</p>
                              <h6>Following</h6>
                              <p>{{user.following}}</p>
                           </b-col> 

                           <b-col md="6" lg="3">
                              <h6>Registered on:</h6>
                              <p>{{user.created_at | formatDateTime}}</p>
                              <h6>Last updated on:</h6>
                              <p>{{user.updated_at | formatDateTime}}</p>
                           </b-col>
                        </b-row>
                     </div>
                  </template>  
               </card>           
               
               <card>
                  <template v-slot:headerTitle>
                        <h6 class="card-title">Vehicle Ads</h6>
                  </template>
                  
                  <template v-slot:body>
                     <div class="details">  
                        <b-row> 
                           <b-col md="6" lg="2">
                              <h6>Total:</h6>
                              <p>{{user.vehicles}}</p>                              
                           </b-col>    

                           <b-col md="6" lg="2">
                              <h6>Pending:</h6>
                              <p>{{user.pending_vehicle}}</p>                              
                           </b-col> 

                           <b-col md="6" lg="2">
                              <h6>Live:</h6>
                              <p>{{user.live_vehicle}}</p>                              
                           </b-col>

                           <b-col md="6" lg="2">
                              <h6>Deactivated:</h6>
                              <p>{{user.deactivated_vehicle}}</p>
                           </b-col>

                           <b-col md="6" lg="2">
                              <h6>Rejected:</h6>
                              <p>{{user.rejected_vehicle}}</p>
                           </b-col>

                           <b-col md="6" lg="2">
                              <h6>Sold:</h6>
                              <p>{{user.sold_vehicle}}</p>
                           </b-col>

                        </b-row>
                     </div>
                  </template>  
               </card> 

               <card>
                  <template v-slot:headerTitle>
                        <h6 class="card-title">Accessories & Spare parts Ads</h6>
                  </template>
                  
                  <template v-slot:body>
                     <div class="details">  
                        <b-row>  

                           <b-col md="6" lg="2">
                              <h6>Total:</h6>
                              <p>{{user.accessories}}</p>                              
                           </b-col>                          

                           <b-col md="6" lg="2">
                              <h6>Pending:</h6>
                              <p>{{user.pending_accessories}}</p>                              
                           </b-col> 

                           <b-col md="6" lg="2">
                              <h6>Live:</h6>
                              <p>{{user.live_accessories}}</p>                              
                           </b-col>

                           <b-col md="6" lg="2">
                              <h6>Deactivated:</h6>
                              <p>{{user.deactivated_accessories}}</p>
                           </b-col>

                           <b-col md="6" lg="2">
                              <h6>Rejected:</h6>
                              <p>{{user.rejected_accessories}}</p>
                           </b-col>

                           <b-col md="6" lg="2">
                              <h6>Sold:</h6>
                              <p>{{user.sold_accessories}}</p>
                           </b-col>

                        </b-row>
                     </div>
                  </template>  
               </card> 

               <card>
                  <template v-slot:headerTitle>
                        <h6 class="card-title">Location</h6>
                  </template>
                  
                  <template v-slot:body>
                     <div class="details">  
                        <b-row>                          

                           <b-col md="12" lg="12">
                              <p>{{user.location}}</p>                              
                           </b-col> 
                           <b-col  md="12">
                              <GmapMap v-if="user.location"
                              :center="center"
                              :zoom="18"
                              map-style-id="roadmap"
                              :options="mapOptions"
                              style="width: 100%; height: 300px"
                              ref="mapRef">                              
                                 <GmapMarker
                                    :position="marker.position"
                                    :clickable="false"
                                    :draggable="false"                                    
                                 />
                           </GmapMap>        
                           </b-col>

                        </b-row>
                     </div>
                  </template>  
               </card> 
          </b-col>
       </b-row>
    </b-container>
</template>
<script>
export default {
   name:'UserDetails',
   data() {
      return {
         user: {},         
         
         user_status: {
            id: "",
            status: ""
         },  

         marker: { position: { lat: 10, lng: 10 } },
         center: { lat: 10, lng: 10 },

         mapOptions: {
            disableDefaultUI: true,
         },       
         
         token: '',
         errors: {}
      };
   },
   mounted () {
      
   },

   created() {
      this.fetchUser();
   },

   methods: {
      
      fetchUser() {
          let url = '/api/admin/users/show?user_id=' + this.$route.params.id ;
            
         this.getToken();
         this.$axios
            .get(url, {headers: {Authorization: 'Bearer ' + this.token,}})
            .then(res => {
               var responseData = res.data.data;               
               this.user = responseData; 

               this.marker.position.lat = parseFloat(this.user.latitude);
               this.marker.position.lng = parseFloat(this.user.longitude);

               this.center.lat = parseFloat(this.user.latitude);
               this.center.lng = parseFloat(this.user.longitude);
               console.log(this.user);             
            })
            .catch(err => console.log(err));
      },   

      getToken() {
         if(localStorage.token) {
            this.token = localStorage.token;
         } else {
            this.$vToastify.error('Session expired, please login again');
            this.$router.push({name: 'auth.login'})
         }
      },

      
   }   
}
</script>